const UTILS = require("../libs/utils.js");
const config = require("../config.js");
const itemTypes = require("./itemTypes.js");
const names = require("./names.js");
var v13428 = Math.PI * 2;
var v13429 = Math.PI / 2;
function Bot(p16567, game, config, p16570) {
  function f2112(p16571, p16572, p16573, p16574) {
    var v13430 = game.store.skins.filter(p16575 => (p16572 == null ? !p16575.type && p16575.weapon == p16571 : p16575.type == p16572) && (p16575.classIndex == null || p16575.classIndex == p16573) && (p16574 == null || (p16575.rarity || 0) <= p16574));
    if (v13430.length) {
      return UTILS.getRandom(v13430).index || -1;
    } else {
      return -1;
    }
  }
  var bot = this;
  p16570 = p16570 || {};
  this.socketId = UTILS.randomString(12);
  this.config = {
    ...config
  };
  if (p16570) {
    for (var v13431 in p16570) {
      if (p16570[v13431] != null) {
        this.config[v13431] = p16570[v13431];
      }
    }
  }
  this.cosmetics = {
    skinColor: -1,
    hairColor: -1,
    skins: [p16570.primSkin || -1, -1],
    hat: p16570.hat || 3168,
    head: p16570.head || -1,
    dye: p16570.dye || 2428,
    body: p16570.body || -1,
    back: p16570.back || -1,
    waist: p16570.waist || -1,
    face: p16570.face || -1,
    shoes: p16570.shoes || -1,
    pet: p16570.pet || -1,
    wrist: p16570.wrist || -1,
    melee: p16570.melee || -1
  };
  this.classIndex = p16570.class || 0;
  this.secondaryIndex = p16570.secondary || 2;
  this.forceClass = p16570.forceClass || false;
  this.team = p16570.team || 0;
  var v13432 = false;
  var v13433 = false;
  this.player = null;
  this.tick = 0;
  this.actionFreq = 0;
  this.target = null;
  this.xray = false;
  this.difficulty = this.config.difficulty || 1;
  this.accuracy = this.config.accuracy || 50;
  this.turnSpd = this.accuracy * this.difficulty * 0.002;
  this.targetDistance = this.config.targetDistance || 1200;
  this.followDistance = 10;
  this.roamRad = this.difficulty * 500;
  this.roamTime = 3500 / this.difficulty;
  this.roamTimer = 0;
  this.roamTarget = null;
  this.startP = {
    x: 0,
    y: 0,
    z: 0
  };
  this.lives = p16570.lives || 0;
  this.canRespawn = true;
  this.name = p16570.name || "Gnomies";
  this.input = [];
  this.scoreOnDeath = false;
  this.spawn = function (p16576) {
    if (bot.canRespawn && bot.config.canRespawn) {
      bot.tick = 0;
      bot.actionFreq = 0;
      bot.target = null;
      if (!bot.forceClass) {
        bot.classIndex = UTILS.getRandom(game.config.classes);
      }
      if (game.classConfig[bot.classIndex].secondary) {
        if (!game.weaponConfig[bot.secondaryIndex] || !game.weaponConfig[bot.secondaryIndex].secondary) {
          bot.secondaryIndex = 2;
        }
      } else {
        bot.secondaryIndex = null;
      }
      var v13434 = bot.player ? bot.player.headMlt : 1;
      if (this.config.randomCosmetics && !v13433) {
        v13433 = true;
        bot.cosmetics.face = f2112(null, itemTypes.FACE, undefined, this.config.cosmeticRarity);
        bot.cosmetics.shoes = f2112(null, itemTypes.SHOE, undefined, this.config.cosmeticRarity);
        bot.cosmetics.hat = f2112(null, itemTypes.HAT, undefined, this.config.cosmeticRarity);
        bot.cosmetics.head = f2112(null, itemTypes.HEAD, undefined, this.config.cosmeticRarity);
        bot.cosmetics.body = f2112(null, itemTypes.BODY, undefined, this.config.cosmeticRarity);
        bot.cosmetics.back = f2112(null, itemTypes.BACK, undefined, this.config.cosmeticRarity);
        bot.cosmetics.waist = f2112(null, itemTypes.WAIST, undefined, this.config.cosmeticRarity);
        bot.cosmetics.pet = f2112(null, itemTypes.PET, undefined, this.config.cosmeticRarity);
        bot.cosmetics.wrist = f2112(null, itemTypes.WRIST, undefined, this.config.cosmeticRarity);
        bot.cosmetics.dye = f2112(null, itemTypes.DYE, undefined, this.config.cosmeticRarity);
        bot.cosmetics.melee = f2112(null, itemTypes.MELEE, undefined, this.config.cosmeticRarity);
        const v13435 = game.classConfig[bot.classIndex].loadout;
        bot.cosmetics.skins = [f2112(v13435[0] + 1, undefined, bot.classIndex, this.config.cosmeticRarity), v13435.secondary ? f2112(bot.secondaryIndex + 1, undefined, bot.classIndex, this.config.cosmeticRarity) : -1];
      }
      bot.player = game.players.add(bot.socketId, null, 0, 0, 0, bot.name, bot.classIndex, bot.cosmetics.skins, bot.cosmetics.face, bot.cosmetics.shoes, bot.cosmetics.hat, bot.cosmetics.head, bot.cosmetics.body, bot.cosmetics.back, bot.cosmetics.waist, bot.cosmetics.pet, bot.cosmetics.wrist, bot.cosmetics.melee, bot.cosmetics.skinColor, bot.cosmetics.hairColor, bot.cosmetics.dye, -1, -1, bot.secondaryIndex, null, bot.team, null, null, null, null, null, null, v13434, null, [], true);
      var v13436 = p16567 || game.getSpawnPoint(bot.team || bot.player.team, bot.player);
      bot.player.team = bot.team || bot.player.team;
      bot.player.x = v13436.x;
      bot.player.y = v13436.y;
      bot.player.z = v13436.z;
      bot.player.setInitPos();
      bot.player.xDire = -((v13436.dir || 0) + 1) * Math.PI / 2;
      bot.player.checkPoint = null;
      bot.player.checkPointList = [];
      bot.player.weaponTier = 0;
      bot.player.lastDeltas = [];
      bot.player.deltaDiv = 1;
      bot.player.sprayIndex = -1;
      bot.player.aloneTime = 0;
      bot.player.playerCardIndex = this.config.randomCosmetics ? f2112(null, itemTypes.PLAYER_CARD, undefined, this.config.cosmeticRarity) : -1;
      bot.player.dmgMlt = this.config.dmgMlt;
      bot.player.speedMlt = this.config.speedMlt;
      bot.player.rangeMlt = this.config.rangeMlt;
      bot.player.healthMlt = this.config.healthMlt;
      bot.player.spreadMlt = this.config.spreadMlt;
      bot.player.noRecoil = !this.config.recoil;
      bot.player.fakeLevel = this.config.level;
      bot.player.fakePremium = this.config.premium;
      bot.player.fakeFeatured = this.config.featured;
      bot.player.fakeClan = this.config.clan;
      if (this.config.healthMlt != 1) {
        bot.player.maxHealth = game.mode && game.mode.maxHealth ? game.mode.maxHealth : bot.player.config.health * (game.config ? game.config.healthMlt || 1 : 1) * (bot.player.healthMlt ? bot.player.healthMlt || 1 : 1);
        bot.player.health = bot.player.maxHealth;
        bot.player.startHealth = bot.player.health;
        game.broadcast("h", bot.player.health, bot.player.sid, null, null, true, true);
      }
      bot.startP = {
        x: bot.player.x,
        y: bot.player.y,
        z: bot.player.z
      };
      if (bot.player.active && !bot.player.spawned) {
        bot.player.spawned = true;
      }
      bot.player.bypassUser = true;
      if (!v13432 && bot.config.joinMessage) {
        v13432 = true;
        for (var vLN02423 = 0; vLN02423 < game.players.list.length; vLN02423++) {
          game.players.list[vLN02423].send("chi", 0, null, [config.serverMessages[0], bot.player.getName(game.players.list[vLN02423].account, true)], 2);
        }
      }
      bot.player.onDeath = bot.onDeath;
      bot.player.onKill = bot.onKill;
      game.players.syncLeaders(true);
      try {
        if (!p16576) {
          game.players.sync();
        }
      } catch (e171) {}
    }
  };
  this.update = function (delta) {
    bot.tick++;
    if (!bot.input.length) {
      bot.input = [0, delta, bot.player.yDire * 1000, bot.player.xDire * 1000, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }
    bot.input[1] = delta;
    bot.input[2] /= 1000;
    bot.input[3] /= 1000;
    bot.input[4] = -1;
    bot.input[7] = 0;
    bot.input[9] = 0;
    bot.actionFreq -= delta;
    if (bot.actionFreq <= 0 && bot.player.active) {
      bot.target = game.findNearestTo(bot.player, bot.player.x, bot.player.y + bot.player.height, bot.player.z, bot.config.targetTeam ? 0 : bot.player.team, bot.targetDistance, bot.xray, true, true, !bot.config.targetBots);
      if (bot.target && bot.target.active) {
        bot.actionFreq = 2000;
      } else {
        bot.target = null;
      }
    }
    var v13437 = bot.target || bot.roamTarget || bot.startP;
    if ((!bot.target || !bot.target.active) && bot.player.active && bot.roamRad && bot.config.roam && (bot.roamTimer -= delta, bot.roamTimer <= 0)) {
      bot.roamTimer = bot.roamTime;
      var v13438 = UTILS.randFloat(-Math.PI, Math.PI);
      bot.roamTarget = {
        x: bot.startP.x + bot.roamRad * Math.cos(v13438),
        y: bot.startP.y,
        z: bot.startP.z + bot.roamRad * Math.sin(v13438)
      };
    }
    var vA745 = [];
    if (v13437.isPlayer && !game.isSandbox) {
      var v13439 = game.players.fetchState(v13437, bot.player);
      vA745 = v13439 ? UTILS.getDrs(v13439, bot.player, config.crouchDst * v13439.cV || 0 || 0) : UTILS.getDrs(v13437, bot.player, config.crouchDst * v13437.crouchVal || 0 || 0);
    } else {
      vA745 = UTILS.getDrs(v13437, bot.player, config.crouchDst * v13437.crouchVal || 0 || 0);
    }
    var v13440 = vA745[0] || 0;
    var v13441 = vA745[1] || 0;
    if (bot.tick % 10 == 0) {
      const v13442 = 0.2 - this.difficulty * 0.2;
      v13440 += v13442;
      v13441 += v13442;
    }
    var v13443 = (bot.input[3] - v13440 + v13428) % v13428;
    var v13444 = Math.min(Math.abs(v13443 - v13428), v13443, bot.turnSpd * delta);
    var v13445 = v13443 - Math.PI >= 0 ? 1 : -1;
    if ((bot.config.watchTarget || bot.config.attackTarget || bot.config.followTarget) && bot.player.active) {
      bot.input[3] += v13445 * v13444 + v13428;
      bot.input[3] %= v13428;
    }
    v13443 = (bot.input[2] - v13441 + v13428) % v13428;
    v13444 = Math.min(Math.abs(v13443 - v13428), v13443, bot.turnSpd * delta);
    v13445 = v13443 - Math.PI >= 0 ? 1 : -1;
    if ((bot.config.watchTarget || bot.config.attackTarget || bot.config.followTarget) && bot.player.active) {
      bot.input[2] += v13445 * v13444;
      bot.input[2] = Math.max(-v13429, Math.min(v13429, bot.input[2]));
    }
    var v13446 = UTILS.getD3D(bot.player.x, bot.player.y, bot.player.z, v13437.x, v13437.y, v13437.z);
    if (bot.config.followTarget && bot.player.active && v13446 >= bot.followDistance) {
      bot.input[4] = 1;
      if (bot.config.slideHop) {
        bot.input[7] = !!bot.player.onGround && !!(bot.player.slideTimer <= 50);
        if (bot.player.velocity.y < 0 && bot.player.canSlide) {
          bot.input[9] = 1;
        }
      }
    }
    if (bot.player.active && bot.config.randomJump) {
      const v13447 = bot.tick % 100 == 0 && UTILS.randInt(0, 100) >= 25;
      if (v13447) {
        bot.input[7] = 1;
      }
    }
    const v13448 = (bot.player.weapon.projectile == null || bot.player.weapon.projectile.disable ? bot.player.weapon.range : bot.player.weapon.projectile.range) * bot.player.rangeMlt;
    if (bot.config.attackTarget && bot.target && bot.target.active && bot.player.active && v13446 < v13448 * 0.5) {
      const v13449 = bot.input[5];
      bot.input[5] = 1;
      if (v13449 && bot.player.weapon.nAuto) {
        bot.input[5] = 0;
      }
    } else {
      bot.input[5] = 0;
    }
    if (bot.config.nodYes) {
      bot.input[2] = bot.tick & 1 ? v13429 / 4 : -(v13429 / 4);
      bot.input[2] = Math.max(-v13429, Math.min(v13429, bot.input[2]));
    }
    bot.input[3] *= 1000;
    bot.input[2] *= 1000;
    if (bot.config.forceCrouch && bot.player.active) {
      bot.input[9] = 1;
    }
    if (bot.spawnDelay && !bot.player.active) {
      bot.spawnDelay -= delta;
      if (bot.spawnDelay <= 0) {
        bot.spawnDelay = 0;
        bot.spawn();
      }
    }
    if (bot.player.active) {
      if (bot.config.mimicTarget && bot.target && bot.target.active) {
        bot.player.inputs = [...bot.target.inputs];
      } else {
        bot.player.inputs.push(bot.input);
      }
    }
  };
  this.onDeath = function () {
    bot.target = null;
    bot.input.length = 0;
    if (bot.lives) {
      bot.lives--;
      if (bot.scoreOnDeath) {
        var v13450 = Math.floor(bot.player.score / 2);
        if (v13450 > 0) {
          game.dropSpawnable(16, bot.player, {
            pnts: v13450
          }, {
            x: bot.player.x,
            y: bot.player.y,
            z: bot.player.z
          });
        }
      }
      if (bot.lives <= 0) {
        if (bot.config.removeOnDeath) {
          game.bots.remove(bot);
          return;
        }
        bot.canRespawn = false;
      }
    }
    if (bot.canRespawn && bot.config.canRespawn) {
      if (bot.config.useSpawnDelay) {
        bot.spawnDelay = config.deathDelay;
      } else {
        bot.spawn();
      }
    }
  };
  this.onKill = function (p16578) {
    if (bot.config.voiceChat) {
      p16578.send("vc", vLSDataaudiooggbase64T2, bot.player.getName(true), bot.player.sid, -1, 1, true);
    }
  };
  this.remove = function () {
    game.removePlayerSound(bot.player.sid, null, true);
    var vO428 = {
      n: bot.player.getName(null, true),
      t: UTILS.getMsgType(bot.player)
    };
    if (game.players.list.indexOf(bot.player) >= 0) {
      game.players.remove(bot.player.sid);
    }
    if (bot.config.leaveMessage) {
      game.broadcast("chi", 0, null, [config.serverMessages[vO428.t], vO428.n], 2, vO428.t > 1 ? "#ff0000" : null);
    }
  };
  this.spreadPlayer = function (p16579) {
    var vO429 = {
      x: p16579.x,
      y: p16579.y,
      z: p16579.z,
      spread: 20,
      dir: 0
    };
    vO429 = game.getPointSpread(vO429.x, vO429.z, vO429.y, vO429.spread + 7, vO429.dir);
    bot.player.x = vO429.x;
    bot.player.y = vO429.y;
    bot.player.z = vO429.z;
  };
  this.estimateDir = function (p16580, p16581) {
    var v13451;
    var v13452 = -1;
    var v13453 = Math.abs(p16580 - p16581[0]);
    for (var vLN02424 = 0; vLN02424 < p16581.length; vLN02424++) {
      v13451 = Math.abs(p16580 - p16581[vLN02424]);
      if (v13451 < v13453) {
        v13453 = v13451;
        v13452 = vLN02424;
      }
    }
    return v13452;
  };
}
class BotManager {
  constructor(p16582) {
    this.game = p16582;
    this.list = [];
    this.config = {
      targetBots: false,
      targetTeam: false,
      forceCrouch: false,
      attackTarget: true,
      followTarget: true,
      watchTarget: true,
      mimicTarget: false,
      slideHop: false,
      canRespawn: true,
      useSpawnDelay: true,
      removeOnDeath: true,
      nodYes: false,
      nodNo: false,
      joinMessage: false,
      leaveMessage: false,
      voiceChat: true,
      godMode: false,
      roam: true,
      dmgMlt: 1,
      speedMlt: 1,
      rangeMlt: 1,
      spreadMlt: 1,
      healthMlt: 1,
      noRecoil: false,
      randomCosmetics: false,
      level: 0,
      premium: 0,
      featured: false,
      clan: 0,
      difficulty: 1,
      randomJump: false,
      cosmeticRarity: undefined,
      accuracy: 50,
      targetDistance: 1200
    };
  }
  add(p16583, p16584, p16585, p16586) {
    var v13454 = new Bot(p16583, this.game, this.config, p16586);
    if (p16584) {
      v13454.spawn(p16585);
    }
    this.list.push(v13454);
    return v13454;
  }
  remove(p16587) {
    var v13455 = this.list.indexOf(p16587);
    p16587.remove();
    this.list.splice(v13455, 1);
  }
  update(p16588) {
    for (var vLN02425 = 0; vLN02425 < this.list.length; vLN02425++) {
      this.list[vLN02425].update(p16588);
    }
  }
  refresh() {
    for (var vLN02426 = 0; vLN02426 < this.list.length; vLN02426++) {
      this.list[vLN02426].spawn(true);
    }
    this.sync();
  }
  spreadAround(p16589) {
    for (var vLN02427 = 0; vLN02427 < this.list.length; vLN02427++) {
      this.list[vLN02427].spreadPlayer(p16589);
    }
  }
  refreshConfig() {
    for (var vLN02428 = 0; vLN02428 < this.list.length; vLN02428++) {
      this.list[vLN02428].config = {
        ...this.config
      };
    }
  }
  reset() {
    for (var v13456 = this.list.length - 1; v13456 >= 0; --v13456) {
      if (!this.list[v13456].persistent) {
        this.remove(this.list[v13456]);
      }
    }
  }
  spawnPersistent() {
    for (var v13457 = this.list.length - 1; v13457 >= 0; --v13457) {
      if (this.list[v13457].persistent) {
        this.list[v13457].spawn(false);
      }
    }
  }
  sync() {
    this.game.players.sync();
  }
  setupLocal() {
    const vA746 = ["StaZ", "X", "EMPY", "Sour", "KRM1", "SHOT", "HIZ", "RGB", "HALO", "GLXY", "SWEL", "Oras", "PNTM", "ＴＨＩＣ"];
    const vA747 = [0, 2, 6, 13];
    for (let vLN02429 = 0; vLN02429 < 5; vLN02429++) {
      const v13458 = UTILS.randInt(vLN02429 == 0 ? 26 : 1, vLN02429 == 0 ? 50 : 25);
      const v13459 = this.add(null, true, false, {
        name: names(),
        targetBots: true,
        randomCosmetics: true,
        cosmeticRarity: v13458 > 25 ? 6 : 2,
        level: v13458,
        featured: !!(v13458 >= 20) && UTILS.randFloat(0, 100) >= 80,
        premium: UTILS.randFloat(0, 100) >= 90 ? 1 : 0,
        clan: v13458 > 25 ? UTILS.getRandom(vA746) : 0,
        difficulty: v13458 > 25 ? 0.75 : UTILS.randFloat(0.1, 0.5),
        randomJump: true,
        dmgMlt: 0.3,
        forceClass: true,
        class: UTILS.getRandom(vA747),
        accuracy: UTILS.randInt(1, 5),
        roam: true,
        targetDistance: 500
      });
      v13459.persistent = true;
    }
  }
}
module.exports = BotManager;
const vLSDataaudiooggbase64T2 = "data:audio/ogg;base64,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";